import { Trans } from '@lingui/macro'
import { Box, FormLabel } from '@mui/material'
import { setAvaliableOrganizations, setOrganization } from 'app/redux/actions/OrganizationActions'
import { createManager, getAccountParsedById } from 'app/services/sfAuth/sfData/sfAccount'
import { saveContactByFlowParsed } from 'app/services/sfAuth/sfData/sfContact'
import { getFormPage } from 'app/services/sfAuth/sfData/sfForms'
import { saveUser } from 'app/services/sfAuth/sfData/sfUser'
import Loading from 'egret/components/EgretLoadable/Loading'
import { useFormikContext } from 'formik'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Form from '../forms/Form'
import { FormType } from '../resources/ResourceInventoryMyEntries/SubmissionsContainer'
import { ResourcesDetailsLightButton } from '../resources/ResourcesDetailsCard/Button'
import { FirstLoginFlowFormikProps } from './index'
import { correctableErrors } from '../forms/FormHelpersValidation'

const createNewOrganizationFormId = 'a3ZON00000024kH2AQ'

export const CreateNewOrganization = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const {
    values, handleChange, handleBlur, setFieldValue, validateForm, setFieldTouched
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const user = useSelector((state: RootStateOrAny) => state.user)
  const dispatch = useDispatch()
  const organization = useSelector((state: RootStateOrAny) => state.organization)
  const avaliableOrganizations = useSelector((state: RootStateOrAny) => state.avaliableOrganizations)
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const [form, setForm] = useState<FormType | null>(null)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = (): void => {
    getFormPage(createNewOrganizationFormId)
      .then((form) => {
        console.log('form', form)
        setForm(form)
      })
  }

  const connectedMap = form?.objectsConnected?.length
    ? Object.fromEntries(
      form.objectsConnected.map((obj) => {
        return [
          obj.identId,
          {
            sfObject: {
              attributes: {
                type: obj.type
              }
            }
          }
        ]
      })
    )
    : {}

  const saveCallback = ({ isValid, savedMap, result }) => {
    setLoading(true)

    if(!result) {
      return
    }

    const accountId = result?.find((r) => r.objectType === 'Account')?.id
    const contactId = user.userObject?.contactId || user.contact?.id || user.contactId

    Promise.all([
      getAccountParsedById(accountId, {
        permissions: { TEAM_MEMBERS: true }
      }),
      saveContactByFlowParsed({
        id: contactId,
        associatedOrganizations: accountId,
        whatAreYouLookingFor: values.goal
      }),
      saveUser({
        Id: user.userId,
        Associated_Organizations__c: accountId
      }),
      createManager({
        title: values.jobTitle,
        organizationId: accountId,
        userId: user.userId,
        contactId
      })
    ]).then(([org, contact, user, manager]) => {
      setLoading(false)
      closeSnackbar()
      dispatch(
        setAvaliableOrganizations([
          ...avaliableOrganizations,
          { id: org.id, name: org.organisationsName }
        ])
      )
      dispatch(setOrganization({ ...org }))
      setFieldValue('displayCreateNewOrganizationDialog', false)
      setFieldValue('displayOrganizationCreatedWindow', true)
    })
  }

  const saveErrorCallback = ({ correctableErrorKey, reject }: { correctableErrorKey: string, reject: Error }) => {
    setLoading(false)
    if (correctableErrorKey) {
      const errorText = correctableErrors[correctableErrorKey].text
      if (errorText) {
        enqueueSnackbar(errorText, { variant: 'error' })
      }
    }
  }

  return (
    <>
      <FormLabel sx={{ textAlign: 'center', fontSize: '24px', lineHeight: '28px', mb: '54px', mt: '-32px' }}>
        <Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      {/* <FormLabel sx={{ mb: '14px' }}>
        <Trans>FIRST_LOGIN_FLOW_CREATE_AN_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <Typography variant='body2' sx={{ fontSize: '12px', lineHeight: '16px', mt: '24px', fontWeight: '600' }}>
        <Trans>FIRST_LOGIN_FLOW_REQUIRED_FIELDS_DESCRIPTION</Trans>
      </Typography> */}

      <Box sx={{ mt: '32px' }}>
        {(form != null)
          ? <Form
              formId={createNewOrganizationFormId}
              renderData={form}
              style={{ padding: 0 }}
              defaultFormType='editable'
              fetchString=''
              saveCallback={saveCallback}
              submitCallback={saveCallback}
              saveErrorCallback={saveErrorCallback}
              saveConnectedMap={connectedMap}
              containerViewType='clean'
              formTitlePrimaryColor
            >
            {({ values, validateForm, setFieldTouched, ...props }) => {
              return (
                <Box sx={{ display: 'flex', pl: '12px', pr: '12px' }}>
                  <ResourcesDetailsLightButton
                    disabled={loading}
                    text={<Trans>FIRST_LOGIN_FLOW_CREATE_ORGANIZATION_BACK_BUTTON</Trans>}
                    onClick={() => {
                      setFieldValue('displayCreateNewOrganizationDialog', false)
                      setFieldValue('displayOrganizationConnectDialog', true)
                    }}
                    sx={{ width: '100%' }}
                  />
                </Box>
              )
            }}
            </Form>
          : <Loading atCenter />}
      </Box>
    </>
  )
}
